import * as IF from "infrontjs";
import { renderLegalHtml } from '../data/legal.js';
import { trackPageView } from '../data/analytics.js';

export class TosState extends IF.State
{
    static ID = 'tos';
    static ROUTE = '/tos';

    async enter()
    {
        trackPageView( 'TosState', '/tos' );

        const appEl = document.getElementById( 'app' );
        const gameEl = document.getElementById( 'game-container' );
        appEl.classList.add( 'active' );
        gameEl.classList.remove( 'active' );

        this.app.view.renderHtml( this.app.container, renderLegalHtml( 'tos' ) );

        document.getElementById( 'pm-legal-back' ).addEventListener( 'click', () =>
        {
            this.app.router.redirect( '/' );
        });
    }

    async exit()
    {
        this.app.container.innerHTML = '';
        document.getElementById( 'app' ).classList.remove( 'active' );
    }
}
